import {
    View
} from "react-native";
import type CustomStatusChipProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";

const CustomStatusChip = ({
    status
}: CustomStatusChipProps) => {
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();
    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    let bgColor = colors.content.container.subtle;
    let textColor = colors.content.text.high;
    let titleText = localize("status");

    if (status === "finished") {
        bgColor = colors.content.container.subtle;
        textColor = colors.content.text.high;
        titleText = localize("events-filter-finished");
    } else if (status === "application") {
        bgColor = colors.project.statusApplication;
        textColor = colors.project.brandWhite;
        titleText = localize("events-filter-application");
    } else if (status === "near") {
        bgColor = colors.project.statusNear;
        textColor = colors.project.brandWhite;
        titleText = localize("events-filter-near");
    } else if (status === "continue") {
        bgColor = colors.project.statusContinue;
        textColor = colors.project.brandWhite;
        titleText = localize("events-filter-continue");
    } else if (status === "announcement") {
        bgColor = colors.project.statusAnnouncement;
        textColor = colors.project.brandWhite;
        titleText = localize("events-filter-announcement");
    }

    return <View
        style={[
            stylesheet.container,
            {
                paddingHorizontal: spaces.spacingLg,
                paddingVertical: spaces.spacingSm,
                borderRadius: radiuses.full,
                backgroundColor: bgColor
            }
        ]}
    >
        <Text
            variant="labelMediumSize"
            customColor={textColor}
        >
            {titleText}
        </Text>
    </View>;
};

export default CustomStatusChip;
